export const PhoneIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.400391 1.5999C0.400391 0.937161 0.937649 0.399902 1.60039 0.399902H4.18384C4.77045 0.399902 5.27107 0.823998 5.36751 1.40262L6.25469 6.72567C6.34129 7.24531 6.07886 7.76067 5.60767 7.99626L3.7499 8.92515C5.08946 12.2539 7.74641 14.9108 11.0751 16.2504L12.004 14.3926C12.2396 13.9214 12.755 13.659 13.2746 13.7456L18.5977 14.6328C19.1763 14.7292 19.6004 15.2298 19.6004 15.8165V18.3999C19.6004 19.0626 19.0631 19.5999 18.4004 19.5999H16.0004C7.38475 19.5999 0.400391 12.6155 0.400391 3.9999V1.5999Z"
      fill="currentColor"
    />
  </svg>
);
